/**
 * @license
 * Copyright TWISS.IO
 * All Rights Reserved.
 * Licensed under the MIT License.
 */
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  appName: 'Legacy FA Pte Ltd',
  production: true,
  // api_url: 'https://secure.legacyfa-asia.com/',
  // secure_ip: '175.111.106.218',
  // epfr_api_url: "https://pfr-api.legacyfa-asia.com",
  api_url: 'https://aims-api.3ktrading-asia.com/',
  secure_ip: '52.221.207.20',
  epfr_api_url: "https://testepfr-api.legacyfa-asia.com",
  fixer_access_key: '052f548e06741679150a49f0d5ee34bf',
  fixer_url: 'https://data.fixer.io/api',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
